module.exports = __webpack_public_path__ + "static/media/Popplio_gaussian2.cfb364a2.png";